import { supabase } from '../config/supabase';

export interface AnalyticsData {
  users: {
    total: number;
    new_7d: number;
    new_30d: number;
    active_7d: number;
    active_30d: number;
    onboarding_done: number;
  };
  items: {
    total: number;
    available: number;
    reserved: number;
    sold: number;
    new_7d: number;
    new_30d: number;
    avg_price: number | null;
    top_categories: Array<{ category: string; item_count: number }>;
  };
  /** Historical only — the in-app payment flow was removed; new sales land in item_sales. */
  transactions: {
    total: number;
    pending: number;
    paid: number;
    completed: number;
    disputed: number;
    cancelled: number;
    /** Marketplace value is reported as traction.gmv_* — see adminAnalytics SQL. */
    avg_deal_value: number | null;
  };
  clubs: {
    total_active: number;
    top_by_members: Array<{ name: string; member_count: number }>;
    top_by_listings: Array<{ name: string; listing_count: number }>;
  };
  engagement: {
    conversion_rate: number;
    messages_7d: number;
    messages_30d: number;
    retention_seller: number;
    retention_buyer: number;
  };
  moderation: {
    open_backlog: number;
    total_handled: number;
    approved: number;
    deleted: number;
    avg_resolution_hours: number | null;
  };
  /** listing → viewed → chat → sold. The payment-offer steps went away with the payment flow. */
  funnel: {
    listings: number;
    items_viewed: number;
    chats_started: number;
    deals_completed: number;
    listings_30d: number;
    items_viewed_30d: number;
    chats_started_30d: number;
    deals_completed_30d: number;
  };
  traction: {
    /** Sale price is optional, so GMV is a floor — read it with gmv_price_coverage_pct. */
    gmv_total: number;
    gmv_30d: number;
    /** % of recorded sales that carry a price. */
    gmv_price_coverage_pct: number;
    /** Sold to a chat partner vs. to someone the seller found outside Clubswap. */
    deals_on_platform: number;
    deals_off_platform: number;
    median_days_to_sale: number | null;
    pct_sold_within_30d: number;
    repeat_sellers: number;
    repeat_buyers: number;
    weekly: Array<{
      week_start: string;
      signups: number;
      new_listings: number;
      deals_completed: number;
      active_chatters: number;
    }>;
  };
}

export const adminAnalyticsService = {
  async getAnalytics(): Promise<AnalyticsData> {
    const { data, error } = await supabase.rpc('get_admin_analytics');
    if (error) throw error;
    return data as AnalyticsData;
  },
};
